<template>
	<div class="setpsword layui-layout layui-layout-admin" style="background:#fff;">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				修改密码
			</div>
		</div>
		<div class="layui-form-item" style="display: none;">
			<!--防止自动填充密码框-->
			<input type="password" maxlength="20" name="password0">
		</div>
		<div class="layui-form px16" style="padding:30px;" action="">
			<div class="layui-form-item">
				<label class="layui-form-label">旧&nbsp;&nbsp;密&nbsp;&nbsp;码</label>
				<div class="layui-input-inline">
					<input type="password" maxlength="20" name="password" required lay-reqText="请输入旧的登录密码" lay-verify="required"
					 placeholder="请输入旧的登录密码" autocomplete="off" class="layui-input">
				</div>
			</div>
			<div class="layui-form-item">
				<label class="layui-form-label">新&nbsp;&nbsp;密&nbsp;&nbsp;码</label>
				<div class="layui-input-inline">
					<input type="password" maxlength="20" name="password1" required lay-reqText="请输入新的登录密码" lay-verify="required"
					 placeholder="请输入新的登录密码" autocomplete="off" class="layui-input">
				</div>
			</div>
			<div class="layui-form-item">
				<label class="layui-form-label">确认密码</label>
				<div class="layui-input-inline">
					<input type="password" maxlength="20" name="password2" required lay-reqText="请再次输入登录密码" lay-verify="required"
					 placeholder="请再次输入登录密码" autocomplete="off" class="layui-input">
				</div>
			</div>
			<button class="nextBtns layui-btn pointer zt_color" style="margin-left:90px;width:448px;margin-top:30px;" lay-submit
			 lay-filter="logins" @click="bntform">提交</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'setpsword',
		data() {
			return {

			}
		},
		created() {

		},
		mounted() {
			let _this = this;
			layui.use(['form', 'layer'], () => {
				let forms = layui.form;
				let layer = layui.layer;
				forms.on('submit(logins)', function(data) {
					layer.open({
						title: '提示',
						content: '是否更改密码',
						btn: ['确定', '取消'],
						closeBtn: 0,
						yes: function(index, layero) {
							api.editPwd({
								token: _this.getCookie('token'),
								befpassword: data.field.password,
								password: data.field.password1,
								repassword: data.field.password2
							}).then((res) => {
								if (res.code == 1) {
									// layer.closeAll();
									layer.msg('修改成功', {
										icon: 1,
										anim: 5
									})
									_this.$router.replace('login')
								} else {
									layer.msg(res.data, {
										icon: 2,
										anim: 6
									})
								}
							})
							return false;
						},
						btn2: function(index, layero) {}
					})
				});

			});
		},
		methods: {
			bntform() {

			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.setpsword {
		font-family: SourceHanSansSC;
	}

	.setpsword input {
		width: 448px;
	}

	#receAddress tr th {
		font-weight: 600;
		font-size: 16px;
	}
</style>



// WEBPACK FOOTER //
// src/components/setpsword.vue